export const enFooterData = {
  backTop: "Back to the top",
  backHome: "Back Home",
  connect: "Let's connect",
  by: "© 2023 | Portfolio website designed and developed by Thiago Correia",
};

export const ptFooterData = {
  backTop: "Voltar ao topo",
  backHome: "Voltar para Home",
  connect: "Vamos nos conectar",
  by: "© 2023 | Site Portfólio desenhado e desenvolvido por Thiago Correia",
};
